export default __webpack_public_path__ + "static/media/card2.759effaf.png";